<div class="template-field-details">

  <div class="details-grid" [formGroup]="detailsFormGroup">
    <sc-dictionary-field [model]="details.label" [defaultLabel]="'label'" style="grid-column: 1; grid-row: 1;"
      (dictionaryChanged)="onDataDictionaryChanged($event)"
      [labelDictionaryKey]="'tmc-yard.entity.document-template-attribute.label'" [required]="false" [maxlength]="255">
    </sc-dictionary-field>
    <mat-form-field style="grid-column: 1; grid-row: 2;">
      <input matInput name="key" formControlName="key" appPositiveInteger
        placeholder="{{'key' | translate:['tmc-yard.entity.document-template-attribute.key', translationService.language]}}"
        [required]="true" [maxLength]="255">
    </mat-form-field>
    <mat-checkbox name="required" formControlName="required" style="grid-column: 1; grid-row: 3;">
      {{'required' | translate:['tmc-yard.entity.document-template-attribute.required',
      translationService.language]}}
    </mat-checkbox>    
    <mat-form-field style="grid-column: 1; grid-row: 4;">
      <mat-label>
        {{'mode' | translate: ['tmc-yard.entity.document-template-attribute.mode',
        translationService.language]}}
      </mat-label>
      <mat-select formControlName="mode">
        <mat-option *ngFor="let m of modeOptions" value="{{m}}">
          {{m | translate: ['tmc-yard.entity.document-template-attribute.mode.'+m, translationService.language]}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field style="grid-column: 1; grid-row: 5;">
      <mat-label>
        {{'type' | translate: ['tmc-yard.entity.document-template-attribute.type',
        translationService.language]}}
      </mat-label>
      <mat-select formControlName="type">
        <mat-option *ngFor="let t of typeOptions" value="{{t}}">
          {{t | translate: ['tmc-yard.entity.document-template-attribute.type.'+t, translationService.language]}}
        </mat-option>
      </mat-select>
    </mat-form-field>    
    <mat-form-field style="grid-column: 1; grid-row: 6;" *ngIf="showSelectDefinitionsSelection">
      <mat-label>
        {{'select definitions' | translate: ['tmc-yard.entity.document-template-attribute.select-definition',
        translationService.language]}}
      </mat-label>
      <mat-select formControlName="selectDefinitionUuid">
        <mat-option *ngFor="let s of templateDetails.selectDefinitions" value="{{s.uuid}}">
          {{s.identifier}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field style="grid-column: 1; grid-row: 7;" *ngIf="showDefaultValue">
      <input matInput name="defaultValue" formControlName="defaultValue"
        placeholder="{{'default value' | translate:['tmc-yard.entity.document-template-attribute.default-value', translationService.language]}}"
        [required]="false" [maxLength]="255">
    </mat-form-field>
    <div style="grid-column: 1; grid-row: 8;" class="align-right">
      <button mat-flat-button (click)="deleteField()">
        <sc-icon iconClass="fa-trash"></sc-icon>
      </button>
    </div>
  </div>

</div>